import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { staticVar } from "../Service/Constats";
import { acessTokenCallback } from "../Service/Api/auth/acessTokenCallback";

export const getAccesstoken = createAsyncThunk(
  "_accessToken",
  async (data,{ rejectWithValue }) => {
    try {
      const response = await acessTokenCallback();
      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      // We got validation errors, let's return those so we can reference in our component and set form errors
      return rejectWithValue(err.response);
    }
  }
);

const initialState = {
  data: {
    keyValue: "id",
    CreatedAt: null,
    DeletedAt: null,
    ID: null,
    UpdatedAt: null,
    email: null,
    first_name: null,
    last_name: null,
    hex_color: null,
    note: "",
    phone: "",
    profile_pic: "",
    role: null,
    role_id: null,
    title: "",
  },
  loader: null,
  loading: staticVar.idle,
  currentRequestId: undefined,
  error: null,
};

export const userSlice = createSlice({
  name: "userData",
  initialState,
  reducers: {
    updateError: (state) => {
      state.error = null;
    },
    addData: (state, action) => {
      state.data = action.payload;
      state.loading = staticVar.done;
    },
    resetData: (state, action) => {
      state = {
        data: initialState,
        loading: staticVar.idle,
        currentRequestId: undefined,
        error: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAccesstoken.pending, (state, action) => {
        if (state.loading === staticVar.idle) {
          state.loading = staticVar.pending;
          state.loader = true;
          state.currentRequestId = action.meta.requestId;
        }
      })
      .addCase(getAccesstoken.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === staticVar.pending &&
          state.currentRequestId === requestId
        ) {
          state.loader = false;
          state.loading = staticVar.idle;
          state.data = action.payload;
          state.currentRequestId = undefined;
        }
      })
      .addCase(getAccesstoken.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === staticVar.pending &&
          state.currentRequestId === requestId
        ) {
          state.loader = false;
          state.loading = staticVar.idle;
          state.currentRequestId = undefined;
          if (action.payload) {
            state.error = {
              ...action.payload.data,
              status: action.payload.status,
            };
          } else {
            state.error = { status: undefined, ...action.error.message };
          }
        }
      });
  },
});

// Action creators are generated for each case reducer function
export const { addData, resetData, updateError } = userSlice.actions;
export const selectUserDatas = (state) => state.userData;
export default userSlice.reducer;
